import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import resourcesToBackend from 'i18next-resources-to-backend';

const locales = import.meta.glob(
  '../../../src/locales/**/*.json'
);

i18n
  .use(
    resourcesToBackend(
      async (lng: string, ns: string) => {
        const path =
          `../../../src/locales/${lng}/${ns.replace(/-/g, '/')}.json`;

        const loader = locales[path];

        if (!loader) {
          console.warn(`Missing locale: ${path}`);
          return {};
        }

        const mod: any = await loader();
        return mod.default;
      }
    )
  )
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: 'pt-BR',
    supportedLngs: ['pt-BR', 'en', 'es'],

    defaultNS: 'common',
    ns: ['common'],

    interpolation: {
      escapeValue: false,
    },

    detection: {
      order: ['navigator', 'localStorage'],
      caches: ['localStorage'],
    },

    react: {
      useSuspense: false,
    },
  });

export default i18n;